// Libraries
import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';

@Directive({
    selector: '[wpClickOutside]'
})
export class ClickOutsideDirective {
  // Public properties
  @Output() public onClickOutside = new EventEmitter();

  /**
   * Creates an instance of ClickOutsideDirective.
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ClickOutsideDirective
   */
  constructor(private elementRef: ElementRef) {
  }

  /**
   * Handles document click listener.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof ClickOutsideDirective
   */
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: any) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.onClickOutside.emit();
    }
  }
}
